import {
    Box,
    Container,
    Flex,
    Highlight,
    Skeleton,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import React from "react";

import CardsCarousel from "@/components/general/cardsCarousel";
import { brandColor } from "@/utilities/color-presets/colorConfig";

const Ciudades = ({ props, data }) => {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const isGreaterThanXl = useBreakpointValue({ base: false, xl: true });
    const isGreaterThan2Xl = useBreakpointValue({ base: false, "2xl": true });

    const showSkeleton = () => {
        if (isGreaterThan2Xl) {
            return (
                <Flex
                    padding="30px 50px"
                    w="100%"
                    h="383px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="#EBEBEB"
                >
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanXl) {
            return (
                <Flex
                    w="100%"
                    h="383px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="#EBEBEB"
                >
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanMd) {
            return (
                <Flex
                    w="100%"
                    h="383px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="#EBEBEB"
                >
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                    <Skeleton w="296px" h="100%" borderRadius="10px" />
                </Flex>
            );
        }

        return (
            <Flex
                w="100%"
                h="383px"
                direction="row"
                alignItems="center"
                justifyContent="center"
                gap="2"
                bg="#EBEBEB"
            >
                <Skeleton w="296px" h="100%" borderRadius="10px" />
            </Flex>
        );
    };

    const redirectPage = (link) => {
        window.open(link, "_blank");
    };
    return (
        <Box
            bgColor="#EBEBEB"
            w="full"
            maxW="100%"
            mx="auto"
            {...props}
            paddingInline="0"
            position="relative"
            mt={12}
            mb={12}
            pb={12}
            pl={3}
            pr={0}
            pt={isGreaterThanMd ? 2 : 10}
        >
            <Box mt={8} mb={8}>
                <Text
                    as="h2"
                    // fontSize={isGreaterThanMd ? '3xl' : '21px'}
                    fontSize={{ base: "md", md: "lg", lg: "2xl" }}
                    textAlign="center"
                >
                    <Highlight
                        query="Conoce el mejor lugar para ti..."
                        styles={{ fontWeight: "700" }}
                    >
                        Conoce el mejor lugar para ti...
                    </Highlight>
                </Text>
            </Box>
            <Box mb={6}>
                <Container maxW="8xl" mx="auto">
                    {(!data || data.length === 0) && showSkeleton()}
                    {data && data.length > 0 && (
                        <CardsCarousel gap={16} isCitiesSection={true}>
                            {data.map((item, index) => (
                                <Flex
                                    justifyContent="center"
                                    flexDirection="column"
                                    overflow="hidden"
                                    flex={1}
                                    key={index}
                                    cursor="pointer"
                                    position="relative"
                                    _hover={{
                                        transform: "translateY(-2px)",
                                        transition: "all 0.3s ease-in-out",
                                    }}
                                >
                                    <Box
                                        height={{ base: "413px", md: "383px" }}
                                        width={{ base: "270px", sm: "318px", md: "296px" }}
                                        position="relative"
                                        borderRadius="10px"
                                        overflow="hidden"
                                        onClick={() => redirectPage(`/${item.cityKey}`)}
                                    >
                                        <Box
                                            position="absolute"
                                            top="0"
                                            left="0"
                                            right="0"
                                            bottom="0"
                                            background={`url(${item.cover_image_url})`}
                                            backgroundPosition="center"
                                            backgroundSize="cover"
                                            backgroundRepeat="no-repeat"
                                        />

                                        <Box
                                            position="absolute"
                                            top="0"
                                            left="0"
                                            right="0"
                                            bottom="0"
                                            bg="linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.38) 100%)"
                                        />
                                        <Box
                                            position="relative"
                                            zIndex={1}
                                            p={4}
                                            height="100%"
                                            display="flex"
                                            flexDirection="column"
                                            justifyContent="flex-start"
                                        >
                                            <Text
                                                as="h2"
                                                // fontFamily={'Poppins'}
                                                fontSize="md"
                                                color="white"
                                                textDecoration="underline"
                                                _hover={{
                                                    textDecoration: "underline",
                                                    ...brandColor,
                                                }}
                                                fontWeight={700}
                                            >
                                                {item.city}
                                            </Text>
                                            <Text
                                                fontSize="sm"
                                                color="white"
                                                mt={2}
                                                _hover={{
                                                    textDecoration: "none",
                                                    ...brandColor,
                                                }}
                                            >
                                                {`${item?.count} ${item?.count === 1 ? "propiedad" : "propiedades"}`}
                                            </Text>
                                        </Box>

                                        <img
                                            src={item.cover_image_url}
                                            alt={`Propiedades en ${item.city}`}
                                            style={{
                                                position: "absolute",
                                                width: "1px",
                                                height: "1px",
                                                opacity: 0,
                                            }}
                                        />
                                    </Box>
                                </Flex>
                            ))}
                        </CardsCarousel>
                    )}
                </Container>
            </Box>
        </Box>
    );
};

export default Ciudades;
